<template>
	<div>
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="page" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<div class="page-header">
				<div class="page-header-container">
					<div class="page-header-inner">
						<div class="fx">
							<div class="page-header-left">
								<div class="page-header-title">
									<h1>TANIX W2</h1>
								</div>
								<div class="content custom">
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.tanix.f')}}</div>
									</div>
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.tanix.s')}}</div>
									</div>
								</div>
								<div class="nav-link">
									<div class="buy-wrap" @click="onBuy">
										{{ $t('buy')}}
									</div>
									<div class="nav-conn">
										<a href="javascript: void (0)" class="link" @click="onTele">
											<span class="iconfont icon-a-telegram"></span>
										</a>
										<a href="javascript: void (0)" class="link pl8" @click="onWhatapp">
											<span class="iconfont icon-whatsapp"></span>
										</a>
									</div>
								</div>
							</div>
							<div class="page-header-right">
								<LazyImage className="viewport" imagePath="/res/img/swiper_1.png"></LazyImage>
							</div>
						</div>
					</div>
				</div>
				<div class="preview-wrap">
					<div class="preview-inner">
						<div class="fx">
							<div class="product-list-wrap">
								<div class="product-item" v-for="(img, index) in imgList" :key="index"
									@click="showPicture(img)">
									<img :src="`/res/img/${img.path}`" alt="" />
								</div>
							</div>
							<!-- <div class="preview-btn">
												<div class="prev link">
									<span class="iconfont icon-zuojiantou"></span>
								</div>
								<div class="next link">
									<span class="iconfont icon-youjiantou"></span>
								</div> 
							</div>-->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="equipment-parameters" id="equipment-parameters">
			<div class="equipment-parameters-wrap">
				<div class="equipment-parameters-inner">
					<h2>{{ $t('feature.specification') }} </h2>
					<h4>{{ $t('feature.product') }} </h4>
					<div class="equipment-content-main">
						<div class="min-equipment">
							<ul class="equipment-ul-list">
								<li v-for="(title, i) in list" :key="i" :class="curIndex == i ? 'active' : ''">
									<a href="javascript: void (0)" @click="checkData(i)">{{ title.category }}</a>
								</li>
							</ul>
							<div class="equipment-table-wrap">
								<table>
									<tbody v-for="(data, idx) in midData" :key="idx">
										<tr class="key">
											<div>{{ data.name }}</div>
										</tr>
										<tr class="val">
											<div>{{ data.value }}</div>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<p class="equipment-content" v-for="(product, index) in list" :key="index">
						<table>
							<thead>
								<tr>
									<th>{{ product.category }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(s, idx) in product.specs" :key="idx">
									<td class="parameters-name">{{ s.name }}</td>
									<td class="parameters-detail">{{ s.value }}</td>
								</tr>
							</tbody>
						</table>
						</p>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
		<div class="dialog" v-show="isShow">
			<div class="mask"></div>
			<div class="dialog-content">
				<div class="dialog-inner" ref="inner" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<img :src="`/res/img/${path}`" alt="">
				</div>
				<div class="close" @click="closePicture" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<span class="iconfont icon-guanbi"></span>
				</div>
				<div class="banner-swiper">
					<div class="prev" @click="onPrev">
						<span class="iconfont icon-zuojiantou"></span>
					</div>
					<div class="next" @click="onNext">
						<span class="iconfont icon-youjiantou"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'TanixW2',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				headerHeight: '',
				isShow: false,
				path: 'tanix/tanix1_2.png', // 使用v-show 需指定默认值
				imgList: [{
						path: 'tanix/tanix1.png',
						dPath: 'tanix/tanix1_2.png'
					},
					{
						path: 'tanix/tanix2.png',
						dPath: 'tanix/tanix2_2.png'
					},
					{
						path: 'tanix/tanix3.png',
						dPath: 'tanix/tanix3_2.png'
					},
					{
						path: 'tanix/tanix4.png',
						dPath: 'tanix/tanix4_2.png'
					},
					{
						path: 'tanix/tanix5.png',
						dPath: 'tanix/tanix5_2.png'
					}
				],
				list: [{
						category: "Packing",
						specs: [{
								name: "Product Dimension",
								value: "105*105*15mm"
							},
							{
								name: "Packaged Size",
								value: "195*115*65cm"
							},
							{
								name: "Packaged Weight",
								value: "0.4KG"
							}
						]
					},
					{
						category: "Hardware",
						specs: [{
								name: "CPU",
								value: "Amlogic S905W2 Quad Core, ARM® Cortex™-A35"
							},
							{
								name: "GPU",
								value: "ARM Mali-G31 MP2"
							},
							{
								name: "RAM",
								value: "4GB"
							},
							{
								name: "ROM",
								value: "32Gb/64Gb"
							},
							{
								name: "DC In",
								value: "DC 5V/2A"
							},
							{
								name: "USB Host",
								value: "2 High speed USB 2.0"
							},
							{
								name: "Card Reader",
								value: "TF Card reader"
							},
							{
								name: "Lan",
								value: "RJ45 Ethernet port"
							},
							{
								name: "Wifi",
								value: "Built-in Wifi, 802.1.1b/g/n"
							},
							{
								name: "AV In",
								value: "AV(3 in 1) port"
							},
							{
								name: "SPDIF",
								value: "Coaxial(Optical)"
							},
							{
								name: "Power Indicator",
								value: "Power On：Blue"
							}
						]
					},
					{
						category: "Software",
						specs: [{
								name: "O.S.",
								value: "Android 11.0"
							},
							{
								name: "KODI",
								value: "17.6"
							},
							{
								name: "Video Formats",
								value: "4K,H.265,MPEG1/2/4,H.264,HD AVC/VC-1,RM/RMVB,Xvid/DivX3/4/5/6,RealVideo8/9/10"
							},
							{
								name: "Music format",
								value: "MP1, MP2, MP3, WMA, OGG, AAC, M4A, FLAC, APE, AMR, RA, WAV"
							},
							{
								name: "Photo format",
								value: "JPEG/BMP/GIF/PNG/TIFF"
							},
							{
								name: "DLNA",
								value: "DLNA files sharing"
							},
							{
								name: "Languages",
								value: "English/French/German/Spanish/Italian etc. 24 languages"
							},
							{
								name: "Network Functions",
								value: "Skype chatting,Picasa,Youtube,Flicker,Facebook,Online movies,etc."
							}
						]
					}
				],
				curIndex: 0,
				url: 'https://auroratvos.com/product/tanix-w2/'
			};
		},
		computed: {
			midData() {
				return this.list[this.curIndex].specs || []
			}
		},
		methods: {
			showPicture(img) {
				this.path = img.dPath
				this.isShow = true
				this.$refs.inner.classList.remove('scale-out-center')
			},
			closePicture() {
				this.isShow = false
				this.$refs.inner.classList.add('scale-out-center')
			},
			checkData(idx) {
				this.curIndex = idx
			},
			getHeaderHeight(val) {
				this.headerHeight = val
			},
			onBuy() {
				window.open(this.url)
			},
			onTele () {
				window.open('https://t.me/AuroraMCPlayer')
			},
			onWhatapp () {
				window.open('https://wa.me/79315988108')
			},
			onPrev () {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if(index > 0) {
					this.path = this.imgList[--index].dPath
				}
			},
			onNext () {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if(index < this.imgList.length - 1) {
					this.path = this.imgList[++index].dPath
				}
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>